module.exports = __webpack_public_path__ + "img/dc-colour.85e0704d.svg";